// TODO: use shared project enum.
export enum CampaignObjective {
  Engagement = 'engagement',
  Growth = 'growth',
  SimpleSms = 'simpleSms',
  LinkOnly = 'linkOnly',
  Automation = 'automation'
}

// TODO: use shared project enum.
export enum CampaignStep {
  Audience = 'audience',
  Template = 'template',
  Design = 'design',
  SMS = 'sms',
  Scheduled = 'scheduled',
  Review = 'review',
  Scheduling = 'scheduling',
  Sending = 'sending',
  Sent = 'sent',
  Failed = 'failed',
  Canceled = 'canceled'
}

export enum CampaignStatus {
  Autoresume = 'auto-resume',
  Draft = 'draft',
  Failed = 'failed',
  Queuing = 'queuing',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent',
  Canceled = 'canceled'
}

export enum ScheduledSendError {
  CreditsTooLow = 'CreditsTooLow',
  RetryException = 'RetryException'
}

export enum CampaignMessageType {
  Sms = 'SMS',
  Mms = 'MMS'
}
